import React from 'react';
import { SCALE_CONSTANTS } from '../../../js/text/scaleUtils';

// Generic Slider Expanded Component
const SliderExpanded = ({
  value,
  onChange,
  min,
  max,
  step,
  unit,
  className,
  labelMin,
  labelMax,
  formatValue,
}) => {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        background: 'rgba(20, 25, 35, 0.98)',
        padding: '2px 15px',
        zIndex: 10,
      }}
    >
      {/* Slider Container */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        {/* Slider */}
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(parseFloat(e.target.value))}
            style={{
              width: '100%',
              height: '6px',
              background: `linear-gradient(to right, #40E0FF 0%, #40E0FF ${percentage}%, rgba(64, 224, 255, 0.3) ${percentage}%, rgba(64, 224, 255, 0.3) 100%)`,
              borderRadius: '3px',
              outline: 'none',
              cursor: 'pointer',
              WebkitAppearance: 'none',
              appearance: 'none',
            }}
            onInput={(e) => {
              const val = parseFloat(e.target.value);
              const perc = ((val - min) / (max - min)) * 100;
              e.target.style.background = `linear-gradient(to right, #40E0FF 0%, #40E0FF ${perc}%, rgba(64, 224, 255, 0.3) ${perc}%, rgba(64, 224, 255, 0.3) 100%)`;
            }}
          />

          {/* Labels */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '6px',
              fontSize: '8px',
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            <span>{labelMin}</span>
            <span>{labelMax}</span>
          </div>
        </div>

        {/* Value display removed */}
      </div>
    </div>
  );
};

// Scale Slider Expanded Component
const ScaleSliderExpanded = ({ scale, handleScaleChange }) => {
  return (
    <SliderExpanded
      value={scale}
      onChange={handleScaleChange}
      min={SCALE_CONSTANTS.SLIDER_MIN}
      max={SCALE_CONSTANTS.SLIDER_MAX}
      step={SCALE_CONSTANTS.SLIDER_STEP}
      unit="%"
      className="scale-slider-expanded"
      labelMin={`${SCALE_CONSTANTS.SLIDER_MIN}%`}
      labelMax={`${SCALE_CONSTANTS.SLIDER_MAX}%`}
      formatValue={(value) => `${Math.round(value)}%`}
    />
  );
};

// Rotate Slider Expanded Component
const RotateSliderExpanded = ({ rotate, handleRotateChange }) => {
  return (
    <SliderExpanded
      value={rotate}
      onChange={handleRotateChange}
      min={-180}
      max={180}
      step={1}
      unit="°"
      className="rotate-slider-expanded"
      labelMin="0°"
      labelMax="360°"
      formatValue={(value) => `${Math.round(value)}°`}
    />
  );
};

export { ScaleSliderExpanded, RotateSliderExpanded };
